import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'

import { SignInPayload, SignInResponse } from './types'

export const signIn = async (values: SignInPayload) => {
  return wretchClient
    .url('/admin/1.0/login')
    .post(values)
    .json<SignInResponse>()
    .catch((err) => {
      toast.error(`${err.response.statusText}: Invalid username or password`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
